import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-2 mb-3" }
const _hoisted_2 = { class: "flex-grow border-2 rounded-sm p-3 border-gray-blue-300 dark:border-gray-bluer-600" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = {
  type: "button",
  class: "mb-1 dragHandle inline-flex py-1 px-1 cursor-move border border-transparent rounded-md text-gray-bluer-300 hover:text-theme dark:text-gray-blue-500 dark:hover:text-gray-blue-200 bg-transparent hover:bg-theme-100 dark:hover:bg-theme-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-500 focus:dark:ring-theme-200 transition duration-150 ease-in-out"
}
const _hoisted_5 = ["onClick"]

import { toRefs, onMounted, onUnmounted, computed, watch } from "vue";
import { useStore }                                        from "vuex";
import { loadFieldSettings }                               from "@ui/mixins/FieldSettings";
import _                                              from "lodash";
import {
    AppButton,
    AppFieldDefault,
    AppFieldErrorIcon,
    useFieldHook
}                                                          from "@greywind/ui";
import VueDraggable                                        from 'vuedraggable';


export default /*#__PURE__*/_defineComponent({
  props: {
        field:      {
            type:     Object,
            required: true
        },
        error:      [ String, Boolean ],
        inputClass: String,
        modelValue: {}
    },
  emits: [ 'update:modelValue' ],
  setup(__props, { emit }) {

const props = __props


const { field, error, inputClass, modelValue } = toRefs( props );


const store = useStore();

const { getInputType, getInputTypeExtras } = loadFieldSettings( store );

const { formField, value, mountEvent, unmountEvent, setInitialValue, fill, handleChange, isReadonly } = useFieldHook(
    {
        emit, field, error, inputClass, modelValue
    }, [], true );

const list     = computed(
    {
        get: () => ( value.value || [] ).map( ( v, index ) => ( { ...v, order: index + 1 } ) ),
        set: array => value.value = array.map( item => {
            delete item.order;

            return item;
        } )
    }
);
const defaults = computed( () => {
    let d = {};

    field.value.fields.forEach( f => d[ f.id ] = f.default !== undefined && f.default !== null ? f.default : '' );

    return d;
} );

onMounted( (): void => {
    value.value = field.value.value || [];

    watch( () => modelValue.value, v => {
        if ( _.isEqual( v, value.value ) || v === null || v === undefined ) return;

        value.value = _.cloneDeep( v );
    }, { deep: true } );
    watch( () => value.value, v => emit( 'update:modelValue', _.cloneDeep( v ) ), { deep: true } );
} );

onUnmounted( (): void => unmountEvent() );

const addToValue = (): void => {
    value.value.push( _.cloneDeep( field.value.default || defaults.value ) );
}

return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!

  return (_openBlock(), _createBlock(_unref(AppFieldDefault), {
    field: _unref(field),
    error: _unref(error)
  }, {
    field: _withCtx(() => [
      _createVNode(_unref(VueDraggable), {
        modelValue: _unref(list),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(list) ? (list).value = $event : null)),
        "item-key": "order",
        tag: "transition-group",
        handle: ".dragHandle",
        "ghost-class": "blockGhost"
      }, {
        item: _withCtx(({element, index}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(field).fields, (f, fi) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${index}_${fi}`,
                  class: _normalizeClass(["flex flex-row", { 'mb-2': fi !== (_unref(field).fields.length - 1) }])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getInputType)(f.type)), {
                    modelValue: _unref(value)[index][f.id],
                    "onUpdate:modelValue": ($event: any) => ((_unref(value)[index][f.id]) = $event),
                    field: {
                                        ..._unref(getInputTypeExtras)( { ...f } ),
                                        clear: true,
                                        value: typeof element[f.id] !== 'undefined' ? element[f.id] : f.default,
                                        textAlign: f.textAlign || 'left',
                                        required: !!f.required || false,
                                        attribute: `${f.attribute}_${index}_${fi}`,
                                        name: `${(f.name || f.id)}_${index}_${fi}`,
                                        label: f.label || null,
                                        stacked: typeof f.stacked === 'boolean' ? f.stacked : true,
                                        placeholder: (f.placeholder || f.label || _unref(field).singular) + ' ' + (index + 1),
                                        extraAttributes: { ...( _ctx.meta && _ctx.meta.attributes ? _ctx.meta.attributes : {} ), autocomplete: (f.name || f.id), ...f.attributes || {} }
                                    }
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "field"]))
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", _hoisted_4, [
                _createVNode(_component_x_icon, {
                  icon: "fontawesome.grip-dots-vertical",
                  "fa-type": "fas",
                  class: "w-4 h-4"
                })
              ]),
              _createElementVNode("span", {
                class: "inline-flex py-1 px-1 border border-transparent rounded-md text-gray-bluer-300 hover:text-red dark:text-gray-blue-500 dark:hover:text-gray-blue-200 bg-transparent hover:bg-red-100 dark:hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 focus:dark:ring-red-200 transition duration-150 ease-in-out cursor-pointer",
                onClick: ($event: any) => (_unref(value).splice(index, 1))
              }, [
                _createVNode(_component_x_icon, {
                  icon: "fontawesome.trash",
                  "fa-type": "fas",
                  class: "w-4 h-4"
                })
              ], 8, _hoisted_5)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (!_unref(field).limit || (_unref(field).limit && _unref(value).length < _unref(field).limit))
        ? (_openBlock(), _createBlock(_unref(AppButton), {
            key: 0,
            onClick: addToValue,
            size: "xsmall",
            class: _normalizeClass({'mt-3': _unref(value) && _unref(value).length}),
            icon: "fontawesome.plus"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Add " + _toDisplayString(_unref(field).singular || _unref(field).label), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_unref(error))
        ? (_openBlock(), _createBlock(_unref(AppFieldErrorIcon), { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["field", "error"]))
}
}

})